module.exports = __webpack_public_path__ + "static/media/analytices7.3391fca4.jpg";